// TODO - remove lint disable when editing this file
/* eslint-disable */
import { createAction } from 'redux-actions'

export const ACTION_INIT = 'ellipsis.init'
export const ACTION_ERROR = 'ellipsis.error'
export const ACTION_INFO = 'ellipsis.info'
export const ACTION_CLEAR_TOAST = 'ellipsis.clear'
export const ACTION_SUCCESS = 'ellipsis.success'
export const ACTION_LEGACY_PREFIX = 'ellipsis.legacy.'
export const initAction = createAction(ACTION_INIT)
export const errorAction = createAction(ACTION_ERROR)
export const infoAction = createAction(ACTION_INFO)
export const clearToastAction = createAction(ACTION_CLEAR_TOAST)
export const successAction = createAction(ACTION_SUCCESS)
